var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram_original"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M106.2 12H37.8C23.5511 12 12 23.5511 12 37.8V106.2C12 120.449 23.5511 132 37.8 132H106.2C120.449 132 132 120.449 132 106.2V37.8C132 23.5511 120.449 12 106.2 12Z",
    fill: "url(#paint0_radial_0_6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M106.2 12H37.8C23.5511 12 12 23.5511 12 37.8V106.2C12 120.449 23.5511 132 37.8 132H106.2C120.449 132 132 120.449 132 106.2V37.8C132 23.5511 120.449 12 106.2 12Z",
    fill: "url(#paint1_radial_0_6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M102 48.432C102 50.1371 101.323 51.7723 100.117 52.978C98.9113 54.1837 97.2761 54.861 95.571 54.861C93.8659 54.861 92.2307 54.1837 91.025 52.978C89.8193 51.7723 89.142 50.1371 89.142 48.432C89.142 46.7269 89.8193 45.0917 91.025 43.886C92.2307 42.6803 93.8659 42.003 95.571 42.003C97.2761 42.003 98.9113 42.6803 100.117 43.886C101.323 45.0917 102 46.7269 102 48.432Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 93.432C74.8141 93.432 77.6006 92.8777 80.2005 91.8008C82.8004 90.7239 85.1627 89.1455 87.1526 87.1556C89.1425 85.1657 90.7209 82.8034 91.7978 80.2035C92.8747 77.6036 93.429 74.8171 93.429 72.003C93.429 69.1889 92.8747 66.4024 91.7978 63.8025C90.7209 61.2026 89.1425 58.8403 87.1526 56.8504C85.1627 54.8605 82.8004 53.2821 80.2005 52.2052C77.6006 51.1283 74.8141 50.574 72 50.574C66.3167 50.574 60.8661 52.8317 56.8474 56.8504C52.8287 60.8691 50.571 66.3197 50.571 72.003C50.571 77.6863 52.8287 83.1369 56.8474 87.1556C60.8661 91.1743 66.3167 93.432 72 93.432ZM72 84.858C75.4101 84.858 78.6806 83.5033 81.092 81.092C83.5033 78.6806 84.858 75.4102 84.858 72C84.858 68.5898 83.5033 65.3194 81.092 62.908C78.6806 60.4967 75.4101 59.142 72 59.142C68.5898 59.142 65.3194 60.4967 62.908 62.908C60.4967 65.3194 59.142 68.5898 59.142 72C59.142 75.4102 60.4967 78.6806 62.908 81.092C65.3194 83.5033 68.5898 84.858 72 84.858Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.142 70.29C29.142 55.89 29.142 48.69 31.95 43.182C34.4149 38.3465 38.3465 34.4149 43.182 31.95C48.684 29.142 55.884 29.142 70.29 29.142H73.716C88.116 29.142 95.316 29.142 100.818 31.95C105.656 34.4139 109.59 38.3456 112.056 43.182C114.858 48.684 114.858 55.884 114.858 70.29V73.716C114.858 88.116 114.858 95.316 112.056 100.818C109.591 105.657 105.657 109.591 100.818 112.056C95.316 114.858 88.116 114.858 73.716 114.858H70.29C55.89 114.858 48.69 114.858 43.182 112.056C38.3456 109.59 34.4139 105.656 31.95 100.818C29.142 95.316 29.142 88.116 29.142 73.716V70.29ZM70.29 37.716H73.716C81.06 37.716 86.052 37.722 89.91 38.04C93.666 38.34 95.586 38.904 96.93 39.582C100.152 41.226 102.774 43.848 104.418 47.076C105.102 48.414 105.66 50.34 105.966 54.096C106.278 57.954 106.29 62.946 106.29 70.29V73.716C106.29 81.06 106.278 86.052 105.966 89.91C105.66 93.666 105.102 95.586 104.418 96.93C102.774 100.153 100.153 102.774 96.93 104.418C95.586 105.102 93.666 105.66 89.91 105.966C86.052 106.278 81.06 106.29 73.716 106.29H70.29C62.946 106.29 57.954 106.278 54.096 105.966C50.34 105.66 48.414 105.102 47.076 104.418C43.8503 102.776 41.2271 100.154 39.582 96.93C38.904 95.586 38.346 93.666 38.04 89.91C37.722 86.052 37.716 81.06 37.716 73.716V70.29C37.716 62.946 37.722 57.954 38.04 54.096C38.34 50.34 38.904 48.414 39.582 47.076C41.2257 43.8491 43.8491 41.2257 47.076 39.582C48.414 38.904 50.34 38.346 54.096 38.04C57.954 37.722 62.946 37.716 70.29 37.716Z",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.878 141.24) rotate(-90) scale(118.929 110.613)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.1 20.64) rotate(78.6806) scale(53.1617 219.135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.46da600ecf37a94ec19c6796e607376d.svg";
export { ForwardRef as ReactComponent };